<main>
  <article>
    <header>
      <img class="i-am-okay-logo" src="../../assets/logo.svg" alt="i-am-okay-logo" />
      <img class="fans-logo" src="../../assets/img/crowd-orange.png" alt="fans-logo" />
      <h3 class="header-title">{{'FANS' | translate}}</h3>
    </header>
    <section class="description" *ngIf="inviter">
      <p>{{'YOU_HAVE_BEEN_INVITED_AND_WILL_GET_UPDATES' | translate: {firstName: inviter.first_name, lastName: inviter.last_name} }}</p>
      <p>{{'ENTER_YOUR_PHONE_NUMBER_TO_BEGIN' | translate}}</p>
    </section>
    <form [formGroup]="form" *ngIf="inviter">
      <label for="phone-number">{{'PHONE_NUMBER' | translate}}</label>
      <div class="input-wrapper">
        <ngx-intl-tel-input
          id="phone-number"
          [cssClass]="'phone-number-input'"
          formControlName="phoneNumber"
          [preferredCountries]="[CountryISO.Netherlands, CountryISO.Germany]"
          [phoneValidation]="true"
          [separateDialCode]="true">
        </ngx-intl-tel-input>
      </div>
      <p class="invalid-phone-number" [class.visible]="showError">{{'ENTER_VALID_MOBILE_PHONE_NUMBER' | translate}}</p>
    </form>
    <footer *ngIf="inviter">
      <button class="start-button" (click)="onSubmit()">{{'START' | translate}}</button>
    </footer>
  </article>
</main>

<ng-template #registrationModal>
  <article class="modal-wrapper">
    <h3 class="modal-title">{{'REGISTRATION_SUCCESFUL' | translate}}</h3>
    <p *ngIf="userAgent !== UserAgent.UNKNOWN" class="modal-body">{{'YOU_ARE_FORWARDED_TO_THE_APP_STORE' | translate}}</p>
    <p *ngIf="userAgent === UserAgent.UNKNOWN" class="modal-body">{{'DOWNLOAD_THE_APP_ON_YOUR_DEVICE' | translate}}</p>
    <button class="modal-button" (click)="closeModalAndRedirect()">{{'CONTINUE' | translate}}</button>
  </article>
</ng-template>
